import { isAllowed } from 'api/Apollo/allower';
import permissions from 'api/Apollo/permissions';

export default function isAllowedToReadEvents() {
  return isAllowed(permissions.readEvents);
}
